import { ComponentsModule } from './../../components/components.module';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WebWeeklyViewPage } from './web-weekly-view';

@NgModule({
  declarations: [
    WebWeeklyViewPage,
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(WebWeeklyViewPage),
  ],
})
export class WebWeeklyViewPageModule {}



// WEBPACK FOOTER //
// ./src/pages/web-weekly-view/web-weekly-view.module.ts